import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Select, Button, message } from 'antd';
import { useData } from '../../contexts/DataContext';

const AddDeviceModal = ({ visible, onCancel }) => {
  const [form] = Form.useForm();
  const [currentStep, setCurrentStep] = useState(0);
  const [isSearching, setIsSearching] = useState(false);

  const {
    addDevice,
    connectBluetooth,
    disconnectBluetooth,
    sendWiFiCredentialsBluetooth,
    bluetoothDevice,
    isBluetoothConnected,
    bluetoothSerialOutput,
  } = useData();

  const handleNext = async () => {
    try {
      await form.validateFields();
      setCurrentStep(prevStep => prevStep + 1);
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };

  const handlePrevious = () => {
    setCurrentStep(prevStep => prevStep - 1);
  };
 console.log('serial output:', bluetoothSerialOutput);  
  const handleFinish = async () => {
    try {
      const values = await form.validateFields();


      if (!isBluetoothConnected) {
        message.error('Bluetooth device is not connected. Please connect first.');
        return;
      }

      await sendWiFiCredentialsBluetooth(values.wifiSSID, values.wifiPassword);
      message.success('Wi-Fi credentials sent successfully');

      // // Wait for a moment to ensure WiFi connection is established
      // await new Promise(resolve => setTimeout(resolve, 5000));

      // const deviceData = {
      //   name: values.deviceName,
      //   attributes: {
      //     sensorType: values.sensorType,
      //     wifiSSID: values.wifiSSID,
      //     // Add any other necessary attributes
      //   }
      // };

      // console.log('Device data to be sent:', deviceData);
      // await addDevice(deviceData);
      
      // message.success('Device added successfully');
      onCancel();
    } catch (error) {
      console.error('Error in handleFinish:', error);
      message.error(`Failed to add device: ${error.message}`);
    }
  };

  const searchBluetoothDevices = async () => {
    setIsSearching(true);
    try {
      await connectBluetooth();
      message.success('Connected to device');
    } catch (error) {
      console.error('Error searching for Bluetooth devices:', error);
      message.error(`Failed to connect to device: ${error.message}`);
    } finally {
      setIsSearching(false);
    }
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <>
            <Form.Item
              name="deviceName"
              label="Device Name"
              rules={[{ required: true, message: 'Please input the device name!' }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="sensorType"
              label="Sensor Type"
              rules={[{ required: true, message: 'Please select the sensor type!' }]}
            >
              <Select>
                <Select.Option value="MPU6050">MPU6050</Select.Option>
                {/* Add more sensor types as needed */}
              </Select>
            </Form.Item>
          </>
        );
      case 1:
        return (
          <>
            <Button onClick={searchBluetoothDevices} disabled={isSearching || isBluetoothConnected}>
              {isSearching ? 'Searching...' : isBluetoothConnected ? 'Connected' : 'Search for Bluetooth Devices'}
            </Button>
            {bluetoothDevice && (
              <div style={{ marginTop: '1rem' }}>
                Selected device: {bluetoothDevice.name}
              </div>
            )}
          </>
        );
      case 2:
        return (
          <>
            <Form.Item
              name="wifiSSID"
              label="WiFi SSID"
              rules={[{ required: true, message: 'Please input the WiFi SSID!' }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="wifiPassword"
              label="WiFi Password"
              rules={[{ required: true, message: 'Please input the WiFi password!' }]}
            >
              <Input.Password />
            </Form.Item>
            <div style={{ marginTop: '1rem' }}>
              <h4>Serial Output:</h4>
              <pre style={{ maxHeight: '200px', overflowY: 'auto', background: '#f0f0f0', padding: '10px' }}>
                {bluetoothSerialOutput}
              </pre>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <Modal
      title="Add New Device"
      visible={visible}
      onCancel={onCancel}
      footer={[
        currentStep > 0 && (
          <Button key="back" onClick={handlePrevious}>
            Previous
          </Button>
        ),
        currentStep < 2 ? (
          <Button key="next" type="primary" onClick={handleNext}>
            Next
          </Button>
        ) : (
          <Button key="submit" type="primary" onClick={handleFinish}>
            Confirm
          </Button>
        ),
      ]}
    >
      <Form form={form} layout="vertical">
        {renderStepContent()}
      </Form>
    </Modal>
  );
};

export default AddDeviceModal;
